import type { ReactNode } from 'react';

interface Props {
  titulo: string;
  descripcion?: string;
  children?: ReactNode;
}

export function PageHeader({ titulo, descripcion, children }: Props) {
  return (
    <header className="space-y-1">
      <h1 className="text-2xl font-bold leading-tight text-texto">{titulo}</h1>
      {descripcion !== undefined && <p className="text-sm text-texto-suave">{descripcion}</p>}
      {children !== undefined && <div className="pt-2">{children}</div>}
    </header>
  );
}
